// extracted by mini-css-extract-plugin
export var chip = "_5b-0";
export var filterDropdown = "_5b-5";
export var filterItem = "_5b-6";
export var icon = "_5b-1";
export var removeButton = "_5b-3";
export var removeIcon = "_5b-4";
export var separator = "_5b-2";